module.exports = __webpack_public_path__ + "img/en.069e7ee5.svg";